export interface IChainEndDeclineRatio {
    centerId: number,
    centerAlias: string,
    isParticipant: boolean,
    chipDeclines: number,
    adpStarts: number,
    nddStarts: number,
    chainStarts: number,
    wlpOffers: number,
    wlpDeclines: number,
    declineRatio: number,
    storedDeclineRatio: number,
    calculatedDeclineRatio: number,
    rank: number,
}